import { render } from "./AllVacancyDepartmentTypes.vue?vue&type=template&id=6aea934e"
import script from "./AllVacancyDepartmentTypes.vue?vue&type=script&lang=js"
export * from "./AllVacancyDepartmentTypes.vue?vue&type=script&lang=js"

import "./AllVacancyDepartmentTypes.vue?vue&type=style&index=0&id=6aea934e&lang=css"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__